import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from "react-redux";
import store from './store';
import { ConfigProvider } from "antd";
import ukUA from 'antd/lib/locale/uk_UA.js';

ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider locale={ukUA}>
      <App />
    </ConfigProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
